import { useMemo } from 'react';
import { kpiRequestsByCompanyStateJ } from '../../../../../services/state/KPI/KPIRequestsStateJ';
import { KPIRequestStatus } from '../../../../../data-models/kpi-requests.data-model';
import { companyStateJ } from '../../../../../services/state/CompanyStateJ';
import { useAtomValue } from 'jotai';

interface IRespondentWarningParams {
  companyId: number;
  respondents: string[] | null;
  initialRespondents: Set<string>;
}
export function useRespondentChangeWarning({
  companyId,
  respondents,
  initialRespondents,
}: IRespondentWarningParams) {
  const requestsByCompany = useAtomValue(kpiRequestsByCompanyStateJ);
  const company = useAtomValue(companyStateJ(companyId));

  return useMemo(() => {
    if (
      !requestsByCompany.get(companyId)?.find((r) => r.status === KPIRequestStatus.Sent) ||
      respondents?.every((r) => initialRespondents.has(r))
    ) {
      return '';
    }
    return `Company ${company?.name} has a request in progress.
    This in-progress request will be sent to the newly added respondent(s).`;
  }, [requestsByCompany, companyId, respondents, initialRespondents, company?.name]);
}
